import type { FC } from "react";
import { useEffect, useRef, useState } from "react";

import type { FontVariant } from "@similarweb/styles";
import { Tooltip } from "@similarweb/ui-components";

import { StyledTextOverflow } from "app/pages/sales-intelligence/common-components/OverflowTooltip/styles";

interface Props {
    text: string;
    fontVariant: FontVariant;
    color: string;
    disabled?: boolean;
    dataAutomation?: string;
}

export const OverflowTooltip: FC<Props> = ({ text, fontVariant, color, disabled, dataAutomation }) => {
    const [isOverflowing, setIsOverflowing] = useState(false);
    const textRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const isTextOverflowing = Boolean(textRef.current && textRef.current.scrollWidth > textRef.current.clientWidth);
        setIsOverflowing(isTextOverflowing);
    }, [text]);

    return isOverflowing && !disabled ? (
        <Tooltip
            placement="top-start"
            content={text}
        >
            <StyledTextOverflow
                fontVariant={fontVariant}
                color={color}
            >
                {text}
            </StyledTextOverflow>
        </Tooltip>
    ) : (
        <StyledTextOverflow
            ref={textRef}
            fontVariant={fontVariant}
            color={color}
            data-automation={dataAutomation}
        >
            {text}
        </StyledTextOverflow>
    );
};
